import { Panel } from '@tovia/man-ui';
import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';

type Props = {
  headline: ReactNode;
  subtitle: ReactNode;
  purchaseFeatures: string[];
  children: ReactNode;
};

export const PurchaseFeaturesPanel = (props: Props) => {
  const { purchaseFeatures } = props;
  const halfIndex = purchaseFeatures.length / 2;
  const leftColumn = purchaseFeatures.slice(0, halfIndex);
  const rightColumn = purchaseFeatures.slice(halfIndex);

  return (
    <StyledPanel className="text-center">
      <Headline>{props.headline}</Headline>
      <Subtitle>{props.subtitle}</Subtitle>
      {props.children}
      <FeaturesListWrapper>
        <List>
          {leftColumn.map((item) => (
            <ListItem key={item}>{item}</ListItem>
          ))}
        </List>
        <List>
          {rightColumn.map((item) => (
            <ListItem key={item}>{item}</ListItem>
          ))}
        </List>
      </FeaturesListWrapper>
    </StyledPanel>
  );
};

const Headline = styled.div`
  font-size: 1rem;

  @media (min-width: 992px) and (max-width: 1199px) {
    font-size: 0.7rem;
  }
`;

export const Subtitle = (props: { children: ReactNode }) => (
  <FeaturesBox>
    <FeaturesSubtext className="features-subtext">
      <small>{props.children}</small>
    </FeaturesSubtext>
  </FeaturesBox>
);

const StyledPanel = styled(Panel)`
  .panel-content {
    padding: 0;
  }
`;

const FeaturesBox = styled.fieldset`
  border-top-width: 1px;
  border-top-style: solid;
  border-color: ${(props) => props.theme.primary3};
  margin: 5px 0 0;
  padding: 0;
`;

const FeaturesSubtext = styled.legend`
  width: inherit;
  font-size: small;
  font-weight: 600;
  text-align: center;
  border: 0;
  margin: 4px auto;
  padding: 5px 15px;
  display: table;
  color: ${(props) => props.theme.primary4};
`;

const FeaturesListWrapper = styled.div`
  width: inherit;
  font-size: smaller;
  padding: 0;
  list-style-type: none;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const List = styled.ul`
  flex: 0 1 max-content;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  ::before {
    margin-left: 4px;
    text-overflow: initial;
    content: '•';
    position: relative;
    top: 2px;
    font-size: small;
    margin-right: 10px;
    font-weight: 700;
    box-sizing: border-box;
    color: ${(props) => props.theme.primary4};
  }
`;
